import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import httpsCall from "../service/httpsCall";

export type User = {
  firstName: string; 
  lastName: string; 
  role: string;
  email: string,
  notification: boolean,
  isEmailVerified: boolean,
  isAccountVerified: boolean,
  profileimageurl: string,
  bio: string,
  phone: string,
  experience: [
    {
      from:string,
      to:string,
      designation: string, 
      companyName: string
      responsibility: string
    }],
  skill: [],
  education: 
  [
    {
      from:string,
      to:string,
      stream: string, 
      institution: string,
      _id: string
    }],
  externalInfo: {name:string}
  address: { 
            country: string, 
            city: string, 
            state: string,
            street: string, 
            zipcode: string
           },
  resumeDetails: [],
};


export type AuthState = {
  isLoggedIn: boolean;
  // isImmigrationRequested: boolean,
  // user: User | null;
  user: {
    education: any[];
    experience: any[];
    resumeDetails: any[];
    [key: string]: any;
  } | null;
};

const initialState: AuthState = {
  isLoggedIn: false,
  // isImmigrationRequested:false,
  user: null,
};
export const updateNotificationSettings = createAsyncThunk(
  "auth/updateNotificationSettings",
  async (notification: boolean, { rejectWithValue }) => {
    try {
      await httpsCall.patch("/profile/all/notification", { notification });
      return notification;
    } catch (error: any) {
      return rejectWithValue(error.response?.data || "Failed to update notification settings");
    }
  }
);

const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    logOut: (state) => {
      state.isLoggedIn = false; 
      state.user = null;
    },
    setUser: (state, action: PayloadAction<User>) => {
      state.user = action.payload;
      state.isLoggedIn = true; 
    },
    updateEducation: (state, action: PayloadAction<any[]>) => {
      if (state.user) {
          state.user.education = action.payload;
      }
    },
    updateExperience: (state, action: PayloadAction<any[]>) => {
      if (state.user) {
          state.user.experience = action.payload;
      }
    },
    updateImmigration: (state, action: PayloadAction<any[]>) => {
      if (state.user) {
          state.user.isImmigrationRequested = action.payload;
      }
    }, 
    
    updateResumeDetails: (state, action: PayloadAction<any[]>) => {
      if (state.user) {
          state.user.resumeDetails = action.payload;
      }
    },    
  },
  extraReducers: (builder) => {
    builder.addCase(updateNotificationSettings.fulfilled, (state, action) => {
      if (state.user) {        
        state.user.notification = action.payload; // Assuming API returns updated notification status
      }
    });
  },
});

export const { logOut, setUser,updateEducation,updateExperience,updateImmigration, updateResumeDetails } = authSlice.actions;
export default authSlice.reducer;
